import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserComponent } from './user.component';
import { UserRoutingModule } from './user-routing.module';
import { CompaniesModule } from './companies/companies.module';
import { CoreModule } from 'src/app/core/core.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ProfileService } from 'src/app/core/services/profile.service';
import { ToastsContainerComponent } from 'src/app/core/components/toast/toasts-container.component';
import { ProfileSettingsComponent } from './profile-settings/profile-settings.component';
import { LogoComponent } from 'src/app/core/components/logo/logo.component';
import { AdminPanelComponent } from './admin-panel/admin-panel.component';
import { AdminAccessHistoryComponent } from './admin-panel/admin-access-history.component';
import { AdminManagementComponent } from './admin-panel/admin-management.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    UserRoutingModule,
    CompaniesModule,
    ReactiveFormsModule,
    ToastsContainerComponent,
    LogoComponent
  ],
  providers: [
    ProfileService
  ],
  declarations: [
    UserComponent,
    ProfileSettingsComponent,
    AdminPanelComponent,
    AdminAccessHistoryComponent,
    AdminManagementComponent,
  ]
})
export class UserModule { }
